module.exports = __webpack_public_path__ + "static/mujeres005-51e421500b9902b25b769a9357e89919.jpg";